export default __webpack_public_path__ + "static/media/money.981e2093.png";